'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MastheadExtensionBasicView = undefined;

var _themeProvider = require('@spp/theme-provider');

var _MastheadExtensionBasicView = require('./MastheadExtensionBasicView');

var _MastheadExtensionBasicView2 = _interopRequireDefault(_MastheadExtensionBasicView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.MastheadExtensionBasicView = _MastheadExtensionBasicView2.default;
exports.default = (0, _themeProvider.themer)('@spp/cn-masthead-extension-basic-view')(_MastheadExtensionBasicView2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/MastheadExtensionBasicView/index.js
 ** module id = 608
 ** module chunks = 1
 **/